import messages from "../../locale/messages";

const validate = values => {

  const errors = {}

  if (!values?.firstName || values?.firstName.trim() == "") {
    errors.firstName = messages.firstNameRequired;
  }

  if (!values?.lastName || values?.lastName.trim() == "") {
    errors.lastName = messages.lastNameRequired;
  }

  return errors
}

export default validate;
